
import { Base } from '../base-component';
import './report-intro.component.scss';

export class ReportIntro extends Base {

	constructor(element: Element){

		super(element);

	}

	init(){

	}

	bindEvents() {

	}
}


// WEBPACK FOOTER //
// ./components/report-intro/report-intro.component.ts